module.exports = __webpack_public_path__ + "img/chairs-outside-pc.2bb462f1.png";